const INPUT_REF_REGEX = /\{\{\s*inputs\.([^}]+)\}\}/g;
const STEP_OUTPUT_REF_REGEX = /\{\{\s*steps\.([^.}]+)\.outputs\.([^}]+)\}\}/g;

export interface StepOutputReference {
  stepId: string;
  key: string;
}

export interface InputReferenceResult {
  inputRefs: string[];
  stepOutputRefs: StepOutputReference[];
}

/**
 * Extracts references to workflow inputs and previous step outputs found within the
 * provided step inputs object. References follow the `{{inputs.foo}}` and
 * `{{steps.stepId.outputs.bar}}` format.
 */
export const extractInputRefs = (inputs: unknown): InputReferenceResult => {
  if (!inputs) {
    return { inputRefs: [], stepOutputRefs: [] };
  }

  let serialized: string;
  try {
    serialized = JSON.stringify(inputs);
  } catch {
    return { inputRefs: [], stepOutputRefs: [] };
  }

  const inputRefs = new Set<string>();
  for (const match of serialized.matchAll(INPUT_REF_REGEX)) {
    const ref = match[1]?.trim();
    if (ref) {
      inputRefs.add(ref);
    }
  }

  const stepOutputRefs: StepOutputReference[] = [];
  for (const match of serialized.matchAll(STEP_OUTPUT_REF_REGEX)) {
    const stepId = match[1]?.trim();
    const key = match[2]?.trim();
    if (stepId && key) {
      stepOutputRefs.push({ stepId, key });
    }
  }

  return {
    inputRefs: Array.from(inputRefs),
    stepOutputRefs,
  };
};
